import React, { ComponentType, ReactElement, ReactNode } from 'react';
import { useDeviceType, DeviceType } from '@cars4ever/public-ui';

import DesktopSkeleton from './DesktopSkeleton';
import styles from './styles.module.scss';
import MobileSkeleton from './MobileSkeleton';
import TabletSkeleton from './TabletSkeleton';

export interface IModelViewerSkeletonProviderProps {
  showSkeleton: boolean;
  children?: ReactNode;
  className?: string;
}

const configSkeleton: Record<DeviceType, ComponentType> = {
  [DeviceType.Mobile]: MobileSkeleton,
  [DeviceType.Tablet]: TabletSkeleton,
  [DeviceType.Desktop]: DesktopSkeleton,
};

const ModelViewerSkeletonProvider = ({ showSkeleton, children }: IModelViewerSkeletonProviderProps): ReactElement => {
  const { deviceType } = useDeviceType();

  const Skeleton = configSkeleton[deviceType];

  if (showSkeleton) {
    return (
      <div className={styles.skeletonWrapper}>
        <Skeleton />
      </div>
    );
  }

  return (
    <>
      {children}
    </>
  );
};

export default ModelViewerSkeletonProvider;
